<template>
    <!-- 合作伙伴  -->
     <main-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg" />
</template>

<script>
import MainPage from '@/views/components/MainPage.vue'
export default {
    name: 'cooperation',
    components: {
        MainPage
    },
    data() {
        return {
            bg: "/img/pay/0--51.png",
        }
    },
    computed: {
        title() {
            return this.$t('cooperation.title');
        },
        subtitle() {
            return this.$t('cooperation.subtitle');
        },
        description() {
            return this.$t('cooperation.description');
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    },
}
</script>